import { responseService } from '@aceroll/platform-hacksaw';

// controllers
import { EvFeatureEnter } from '../controllers/ev-feature-enter';
import { EvMaxWin } from '../controllers/ev-max-win';
import { EvRespin } from '../controllers/ev-respin';
import { RoundCompleted } from '../controllers/round-completed';

export function evRevealDecision() {
    const event = responseService.getEvent();

    if (!event) { return RoundCompleted; }

    switch (event.type) {
        case 'feature_enter':
            return EvFeatureEnter;
        case 'respin':
            return EvRespin;
        case 'max_win_reached':
            return EvMaxWin;
        default:
            return RoundCompleted;
    }
}